<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Price Injection</h2>
      <v-card class="mt-4">
      <PriceInjection/>
  </v-card>
  </div>
</template>

<script>
import PriceInjection from '@/components/Utils/PriceInjection.vue'
  export default {
    components: {
      PriceInjection
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>